import { Union, Record } from "../../fable_modules/fable-library-js.4.24.0/Types.js";
import { Currency_$reflection, Currency, Money_ByCurrency, Money_$reflection, SKU_$reflection } from "../../Shopfoo.Domain.Types/Common.js";
import { class_type, option_type, decimal_type, union_type, record_type, bool_type } from "../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { icon } from "../../Components/Icon.js";
import arrow_up_wide_short from "@iconify-icons/fa6-solid/arrow-up-wide-short";
import arrow_down_wide_short from "@iconify-icons/fa6-solid/arrow-down-wide-short";
import circle_plus from "@iconify-icons/fa6-solid/circle-plus";
import eraser from "@iconify-icons/fa6-solid/eraser";
import ban from "@iconify-icons/fa6-solid/ban";
import { Prices_$reflection, Prices, RetailPrice as RetailPrice_1 } from "../../Shopfoo.Domain.Types/Sales.js";
import { orElse, toArray, defaultArg } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { fromParts } from "../../fable_modules/fable-library-js.4.24.0/Decimal.js";
import { Stock_$reflection } from "../../Shopfoo.Domain.Types/Warehouse.js";
import { iterate } from "../../fable_modules/fable-library-js.4.24.0/Seq.js";

export class ProductModel extends Record {
    constructor(SKU, SoldOut) {
        super();
        this.SKU = SKU;
        this.SoldOut = SoldOut;
    }
}

export function ProductModel_$reflection() {
    return record_type("Shopfoo.Client.Pages.Product.ProductModel", [], ProductModel, () => [["SKU", SKU_$reflection()], ["SoldOut", bool_type]]);
}

export const PriceAction_Icons_increase = icon(arrow_up_wide_short);

export const PriceAction_Icons_decrease = icon(arrow_down_wide_short);

export const PriceAction_Icons_define = icon(circle_plus);

export const PriceAction_Icons_remove = icon(eraser);

export const PriceAction_Icons_soldOut = icon(ban);

export class PriceIntent extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Increase", "Decrease", "Define"];
    }
}

export function PriceIntent_$reflection() {
    return union_type("Shopfoo.Client.Pages.Product.PriceIntent", [], PriceIntent, () => [[], [], []]);
}

export class PriceType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ListPrice", "RetailPrice"];
    }
}

export function PriceType_$reflection() {
    return union_type("Shopfoo.Client.Pages.Product.PriceType", [], PriceType, () => [[], []]);
}

export class PriceModel extends Record {
    constructor(Type, Value, Intent) {
        super();
        this.Type = Type;
        this.Value = Value;
        this.Intent = Intent;
    }
}

export function PriceModel_$reflection() {
    return record_type("Shopfoo.Client.Pages.Product.PriceModel", [], PriceModel, () => [["Type", PriceType_$reflection()], ["Value", Money_$reflection()], ["Intent", PriceIntent_$reflection()]]);
}

export function PriceModel__Update_55085C3A(this$, prices) {
    if (this$.Type.tag === 1) {
        return new Prices(prices.SKU, prices.Currency, new RetailPrice_1(0, [this$.Value]), prices.ListPrice);
    }
    else {
        return new Prices(prices.SKU, prices.Currency, prices.RetailPrice, this$.Value);
    }
}

export function PriceType__To(this$, intent, value) {
    return new PriceModel(this$, value, intent);
}

export function PriceType__ToDefine_Z55B79C7B(this$, initialCurrency) {
    return new PriceModel(this$, Money_ByCurrency(defaultArg(initialCurrency, new Currency(0, [])), fromParts(1, 0, 0, false, 2)), new PriceIntent(2, []));
}

export class Drawer extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ManagePrice", "InputSales", "ReceivePurchasedProducts", "AdjustStockAfterInventory"];
    }
}

export function Drawer_$reflection() {
    return union_type("Shopfoo.Client.Pages.Product.Drawer", [], Drawer, () => [[["Item1", PriceModel_$reflection()], ["Item2", Prices_$reflection()]], [["Item1", Currency_$reflection()], ["defaultSalePrice", option_type(decimal_type)]], [["Item", Currency_$reflection()]], [["Item", Stock_$reflection()]]]);
}

export class DrawerControl {
    constructor(open$0027, close) {
        this["open\'"] = open$0027;
        this.close = close;
        this.onOpenListeners = [];
        this.onCloseListeners = [];
        this.openedDrawer = undefined;
    }
}

export function DrawerControl_$reflection() {
    return class_type("Shopfoo.Client.Pages.Product.DrawerControl", undefined, DrawerControl);
}

export function DrawerControl_$ctor_662CADE(open$0027, close) {
    return new DrawerControl(open$0027, close);
}

export function DrawerControl__OnOpen_Z63060278(this$, f) {
    void (this$.onOpenListeners.push(f));
}

export function DrawerControl__OnClose_Z63060278(this$, f) {
    void (this$.onCloseListeners.push(f));
}

export function DrawerControl__Open_Z6ACBEE1E(this$, drawer) {
    this$["open\'"](drawer);
    iterate((f) => {
        DrawerControl__invokeWith(this$, drawer, f);
    }, this$.onOpenListeners);
    this$.openedDrawer = drawer;
}

/**
 * `drawer` is used optionally to specify the new drawer data to listeners, to pass saved values for example.
 */
export function DrawerControl__Close_52723E41(this$, drawer) {
    iterate((drawer_1) => {
        iterate((f) => {
            DrawerControl__invokeWith(this$, drawer_1, f);
        }, this$.onCloseListeners);
        this$.openedDrawer = undefined;
    }, toArray(orElse(drawer, this$.openedDrawer)));
    this$.close();
}

export function DrawerControl__invokeWith(this$, x, f) {
    return f(x);
}

